/**
 * Form field sanitizers
 * Clean and normalize form input values
 */

export const sanitizers = {
  phone: (value: string): string => value.replace(/\D/g, ''),
  ein: (value: string): string => value.replace(/\D/g, ''),
  zip: (value: string): string => value.replace(/\D/g, ''),
  state: (value: string): string =>
    value
      .replace(/[^A-Za-z]/g, '')
      .toUpperCase()
      .slice(0, 2),
  name: (value: string): string => value.trim(),
  email: (value: string): string => value.trim().toLowerCase(),
  currency: (value: string): string => {
    // Remove $, commas, spaces, +, and - signs, keep only numbers and decimal point
    return value.replace(/[$,\s+-]/g, '').replace(/[^\d.]/g, '');
  },
  percentage: (value: string): string => {
    // Remove %, spaces, +, and - signs, keep only numbers and decimal point
    return value.replace(/[%\s+-]/g, '').replace(/[^\d.]/g, '');
  },
  numeric: (value: string): string => {
    // Remove +, -, and other non-numeric characters except decimal point
    return value.replace(/[+\s-]/g, '').replace(/[^\d.]/g, '');
  },
};
